<template>
  <div class="app-container">
    <div v-if="itemTitle" class="w800 tab-title">{{itemTitle}}</div>
    <div class="tab-description">{{itemDescription}}</div>
    <div v-if="isEmpay" class="empty-data">{{ $t("translate.no_record") }}</div>

    <!-- list view  -->
    <div v-if="!isEmpay && view =='list'" class="app-item-list" :class="view =='list' ? 'app-item-list_viewList':'app-item-list_gridView'">
      <v-card v-for="(goods, index) in itemsList" :key="index" class="row" @click="handleItem(goods)"
        ripple 
        :flat="window.width <= 950 && view =='list' ? true : false" 
        :tile="window.width <= 950 && view =='list' ? true : false" 
        :class="{'bottom-border':window.width <= 950 && view =='list'? true : false}"
        >
        <div class="row-item" :class="view =='list' ? 'row-item_viewList' : 'row-item_viewGrid'">
          <div class="item-image">
            <div class="item-image-cont">
              <span v-if="goods.ispre_order == 1 && goods.preorderItem == true && parseInt(goods.counts) != 0 && goods.available == 1" class="preorder">PRE-ORDER</span>
              <span v-else-if="goods.available == 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0)" class="preorder">UNAVAILABLE</span>
              <img :class="{'imgoutstock':parseInt(goods.counts)==0 || (parseInt(goods.counts) - parseInt(goods.today_counts) == 0)}" :src="goods.thumb" />
            </div>
          </div>

          <div class="flex1 item-content">
            <div class="item-info " :class="{'outofstock':parseInt(goods.counts)==0 || (parseInt(goods.counts) - parseInt(goods.today_counts) == 0) || goods.available == 0}">
              <div class="flex justify-between p100">
                <div class="item-name">
                  {{goods.title}} 
                  <div v-if="parseInt(goods.counts) == 0 || (parseInt(goods.counts) - parseInt(goods.today_counts) == 0)" class="out-of-stock">{{ $t("translate.sold_out") }}</div>
                  <div v-else-if="goods.available == 0" class="out-of-stock">Unavailable</div>
                </div>
              </div>

              <div class="item-choosed p100" v-if="cart_chooselist && cart_chooselist[goods.sku]">
                <div v-for="(selectedItem, selectedIndex) in cart_chooselist[goods.sku]" :key="selectedIndex">{{selectedItem}}</div>
              </div>
              <div v-else class="item-desc flex p100">
                {{goods.description}}
              </div>

                <!-- preparation time-->
              <div>
                <span v-if="(parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && (goods.istime > 0 || goods.fullWeek == false)" class="item-preorder">Available On:</span>
                <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.istime == 1"><span class="preOrder">{{goods.startdate}} - {{goods.enddate}}</span><span class="preOrder">{{goods.begintime}} - {{goods.endtime}}</span></span>
                <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.istime == 2" class="preOrder">{{goods.startdate}} - {{goods.enddate}}</span>
                <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.istime == 3" class="preOrder">{{goods.begintime}} - {{goods.endtime}}</span>
                <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.fullWeek == false" class="preOrder">{{goods.days}}</span> 
              </div>
              <!-- available time -->
              <div v-if="parseInt(goods.counts) != 0 && goods.preparation_time > 0 && goods.  prepare_time_display == 1 && goods.available == 1">
                <span class="item-prepare">Preparation Time: </span>
                <span v-if="goods.preparation_time < 60" class="prepare">{{goods.preparation_time}} Minutes</span>
                <span v-if="goods.preparation_time >= 60" class="prepare">{{goods.preparation_time_display}}</span>
              </div>

            </div>
          </div>
        </div>

        <div class="item-price" v-if="goods && goods.productprice">
          <div><span v-if="goods && goods.goods_attr_list.length >0">from</span> 
            RM {{ fmPrice(goods.marketprice) }}
          </div>
          <div class="ori-price" v-if="goods.productprice">{{ fmPrice(goods.productprice) }}</div>
        </div>
        <div class="item-price" v-else><div>
            <span v-if="goods && goods.goods_attr_list.length >0">from</span> RM {{ fmPrice(goods.marketprice) }}</div>
        </div>
      </v-card>
    </div>

    <!-- grid view  -->
    <div v-if="!isEmpay && view =='grid'" class="app-item-list" :class="view =='list' ? 'app-item-list_viewList':'app-item-list_gridView'">
      <v-card v-for="(goods, index) in itemsList" :key="index" class="row" 
        :flat="window.width <= 950 && view =='list' ? true : false" 
        :tile="window.width <= 950 && view =='list' ? true : false" 
        :class="{'bottom-border':window.width <= 950 && view =='list'? true : false}">

        <div class="row-item" :class="view =='list' ? 'row-item_viewList' : 'row-item_viewGrid'">
          <div class="item-image">
            <div @click="handleItem(goods)" class="item-image-cont">
              <span v-if="goods.ispre_order == 1 && goods.preorderItem == true && parseInt(goods.counts) != 0 && goods.available == 1" class="preorder">PRE-ORDER</span>
              <span v-else-if="goods.available == 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0)" class="preorder">UNAVAILABLE</span>
              <img :class="{'imgoutstock':parseInt(goods.counts)==0 || (parseInt(goods.counts) - parseInt(goods.today_counts) == 0)}" :src="goods.thumb" />


              <!-- button - + change quantity -->
              <div v-if="cart_goodslist.some(e => e.goods_id == goods.id && e.qty>0)">
                <div class="btn-best-cont" v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.available != 0">
                  <div v-if="cart_goodslist.some(e => e.goods_id == goods.id)" class="btn-edit">
                      <div>
                          <div class="btn-edit" v-if="reduceItemCartTotal(goods)>0">
                              <v-btn v-if="reduceItemCartTotal(goods)<2" icon small class="buttonIcon" @click.stop="delItem(goods,index)">
                                  <v-icon size="17">
                                      {{ icons.mdiTrashCanOutline}}
                                  </v-icon >
                              </v-btn>
                              <v-btn v-else icon small @click.stop="MinusQty(goods)" class="buttonIcon">
                                  <v-icon size="22">{{icons.mdiMinus}}</v-icon>
                              </v-btn>

                              <div class="mx-1 size14">{{reduceItemCartTotal(goods)}}</div>
                            
                              <v-btn icon small class="buttonIcon" @click.stop="PlusQty(goods)">
                                  <v-icon size="22">{{icons.mdiPlus}}</v-icon>
                              </v-btn>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <!-- button add to cart -->
              <div v-else>
                <div class="btn-best-cont" v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.available != 0">
                  <v-btn elevation="8" icon small class="bg-main" @click.stop="clickAddBtn(goods)">  
                    <v-icon size="20">
                      {{icons.mdiPlus}}
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <div class="flex1 item-content">
            <div class="item-info" :class="{'outofstock':parseInt(goods.counts)==0 || (parseInt(goods.counts) - parseInt(goods.today_counts) == 0) || goods.available == 0}">
              <div class="flex justify-between p100">
                <div class="item-name" @click="handleItem(goods)">
                  {{goods.title}}
                  <div v-if="parseInt(goods.counts) == 0 || (parseInt(goods.counts) - parseInt(goods.today_counts) == 0)" class="out-of-stock">{{ $t("translate.sold_out") }}</div>
                  <div v-else-if="goods.available == 0" class="out-of-stock">Unavailable</div>
                </div>
              </div>
              <div class="item-choosed p100" v-if="cart_chooselist && cart_chooselist[goods.sku]">
                <div v-for="(selectedItem, selectedIndex) in cart_chooselist[goods.sku]" :key="selectedIndex">{{selectedItem}}</div>
              </div>
              <!-- <div v-else class="item-desc flex p100">
                {{goods.description}}
              </div> -->
            </div>
          </div>
            <!-- preparation time-->
          <div class="px-2">
            <span v-if="(parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && (goods.istime > 0 || goods.fullWeek == false)" class="item-preorder">Available On:</span>
            <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.istime == 1"><span class="preOrder">{{goods.startdate}} - {{goods.enddate}}</span><span class="preOrder">{{goods.begintime}} - {{goods.endtime}}</span></span>
            <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.istime == 2" class="preOrder">{{goods.startdate}} - {{goods.enddate}}</span>
            <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.istime == 3" class="preOrder">{{goods.begintime}} - {{goods.endtime}}</span>
            <span v-if="parseInt(goods.counts) != 0 && (parseInt(goods.counts) - parseInt(goods.today_counts) != 0) && goods.fullWeek == false" class="preOrder">{{goods.days}}</span> 
          </div>
          <!-- available time -->
          <div class="px-2" v-if="parseInt(goods.counts) != 0 && goods.preparation_time > 0 && goods.  prepare_time_display == 1 && goods.available == 1">
            <span class="item-prepare">Preparation Time: </span>
            <span v-if="goods.preparation_time < 60" class="prepare">{{goods.preparation_time}} Minutes</span>
            <span v-if="goods.preparation_time >= 60" class="prepare">{{goods.preparation_time_display}}</span>
          </div>
        </div>

        <div class="item-price" v-if="goods && goods.productprice">
          <div>
            <span v-if="goods && goods.goods_attr_list.length >0">
              from
            </span> 
            RM {{ fmPrice(goods.marketprice) }}
          </div>
          <div class="ori-price" v-if="goods.productprice">
            {{ fmPrice(goods.productprice) }}
          </div>
        </div>

        <div class="item-price" v-else>
          <div>
            <span v-if="goods && goods.goods_attr_list.length >0">
              from
            </span> 
            RM {{ fmPrice(goods.marketprice) }}
          </div>
        </div>
      </v-card>
    </div>

      <van-popup v-model="show" get-container="#app" :style="{ background:'#ffffff',height:'100%'}" class="attr-wapper">
          <GoodsAttr :key="timeVal" :attrList="currentGood.goods_attr_list" :goods="currentGood" :chooseList="curChooseList" @evtClosePopup="closeEditPopup" @evtChooseAttr0="chooseEditAttr" @evtIsRequired="setIsRequired" @evtGoBack="goBack" />

          </van-popup>
          <van-popup v-model="show" :overlay="false" get-container="#app" position="bottom" >
          <div class="attr-bottom">
              <div ref="posBottom" class="pos-bottom">
                  <div class="goods-inventory" v-if="currentGood.counts>=1">{{ $t("translate.stock_quantity") }}: {{currentGood.counts}} pcs</div>

                  <div class="select-quanity">
                      <van-stepper v-model="qty" disabled-input="true" input-width="40px" button-size="40px" @minus="getCurrentAttrTotal" @plus="getCurrentAttrTotal" />
                      <v-btn tile retain-focus-on-click :disabled="!isRequired" class="confirm-btn bg-main" :class="{'btn-on-bg':isRequired, 'btn-off-bg':!isRequired, 'no-more-item':(parseInt(currentGood.counts)>=1 && parseInt(qty)>parseInt(currentGood.counts))?true:false }" @click="updateAndSave">{{ $t("translate.confirm_update") }} - {{ currentAttrTotal }}</v-btn>
                  </div>
                  
              </div>
          </div>
      </van-popup>

      <van-popup v-model="cartdrawer" get-container="#app" position="bottom" :style="{ background:'#fff',minheight:'30%', maxHeight:'60%'}">
        <ChooseExistedItemVue :goods="tempGoods" v-if="cartdrawer" @evtEditFilterItem="editItem" @evtFilterItem="clickShowPopup" @close="cartdrawer= false" />
      </van-popup>

  </div>
</template>
<script>
import { mapGetters,mapActions } from 'vuex'
import { cartMixin } from '@/mixins/cartMixin'
import { getGoodsDetail, validateBusinessAndHoliday,updateDishnumOfCategory } from '@/api/api'
import { mdiPlus,mdiMinus,mdiTrashCanOutline } from '@mdi/js';
import GoodsAttr from "@/components/common/GoodsAttr.vue";
import { NOT_FOUND_IMAGE_URL } from '@/constants'

import ChooseExistedItemVue from '../common/ChooseExistedItem.vue';

export default {
  props: {
    defaultView: {
      type: String
    },
    itemTitle: {
      type: String,
      default: ''
    },
    itemDescription: {
      type: String,
      default: ''
    },
    itemsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      cartdrawer: false,
      tempGoods: {},
      stop:false,
      view: this.defaultView == '0' ? 'list' : 'grid',
      icons:
      {
        mdiPlus,
        mdiMinus,
        mdiTrashCanOutline
      },
      window: {
        width: 0,
      },
      indexPage: {},
      setChooseListTotal: 0,
      ooj: {},
      isRequired: false, //true所有的必选项都已经符合条件， 反之不符合条件，则不能提交确认和修改数据
      show:false,
      currentGood: {},
      // qty: 1,
      currentAttrTotal: 0.0,
      currentAttr: {},
      isSelectedAttr: false,
      timeVal: "",
      curChooseList: [], //点击当前购物车item弹窗时获取选中的规格信息
      newGoodsData: {}, //点击购物车列表中的某商品时获取到最新的数据

      //是否为空
      isEmpay: true,
      //选中商品的数量
      qty: 0,
      //选择中商品价格
      price: 0,
      store: {},
      notfoundimage: 'https://restaurant.fastorder.my/attachment/images/2/2020/01/rhfi799j4R9I4RPrKH9357Zwz8jIPi.jpg'
    }
  },
  mixins: [cartMixin],
  computed: {
    ...mapGetters([
      'cart_goodslist', 
      'cart_chooselist', 
      'store_info',
      'cart_productqty',
      "products",
      'cart_subtotal'
    ])
  },
  components: {
    GoodsAttr,
    ChooseExistedItemVue
    
  },
  created () {
    this.initData();
    if(this.$route.query.pid != undefined){
      this.itemsList.forEach(item =>{
        if(item.id == this.$route.query.pid){
          setTimeout(()=>{
            this.showPopup(item) 
          },10)
        }
      })
    }
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
  watch: {
    defaultView:function(){
      this.view= this.defaultView == '0' ? 'list' : 'grid'
    },
    '$route.query':function(){
      if(this.$route.query.pid != undefined){
        if(this.$route.query.pid != undefined){
          this.itemsList.forEach(item =>{
            if(item.id == this.$route.query.pid){
              this.showPopup(item) 
            }
          })
        }
      }
    },
  },
  methods: {
    ...mapActions({
      settingGoodsList: "shoppping_cart/settingGoodsList",
      resetCart: "shoppping_cart/resetShoppingCart",
      settingProductQty: "shoppping_cart/settingProductQty",
      cleanCart: "shoppping_cart/cleanShoppingCart",
      settingQty: "shoppping_cart/settingQty",
      settingSubtotal: "shoppping_cart/settingSubtotal",
      settingChooseList: "shoppping_cart/settingChooseList",
      setRadioAddons: "shoppping_cart/settingRadioGoodsAddons",
      settingAttrRadio: "shoppping_cart/setAttrRadio",
    }),
    clickAddBtn(goods){
        this.stop= true;
        if(goods.goods_attr_list.length >0){
            this.stop=false
            this.handleItem(goods)
        }else {
            this.checkItem(goods)
            setTimeout(()=>{
                this.stop= false
            },10)
        }
    },
    reduceItemCartTotal(goods){
      let x =this.cart_goodslist.filter(e => e.goods_id == goods.id)
      let total = 0
      x.forEach(cart =>{
        total += parseInt(cart.qty)
      })
      return total
    },
    handleResize() {
      this.window.width = window.innerWidth;
      // console.log('view',this.view)
      // console.log('default view',this.defaultView)
      if(window.innerWidth > 950){
        this.view = 'list'
      }else {
        this.view = this.defaultView == '0' ? 'list' : 'grid'
      }
    },
    initData () {
      //根据参数[itemsList]的内容判断出是否有数据
      this.isEmpay = this.itemsList.length == 0
    },

    handleItem(goods) {
      console.log('goods...',goods)
      console.log('cart_goodslist',this.cart_goodslist) 

      let ifItemExist = this.cart_goodslist.some(item => item.goods_id === goods.id)

      if(ifItemExist){
        if(this.cart_goodslist.length !=0 && goods.goods_attr_list.length>0){
          this.tempGoods = goods
          this.cartdrawer =true
        }else{
          let filteritem = this.cart_goodslist.filter(e => e.goods_id == goods.id)[0]
          this.editItem(filteritem)
        }
      }else {
        this.clickShowPopup(goods)
      }
    },
    clickShowPopup(goods){ 
      let queryObjs = location.href.split("?")[1]
      function parseParms(str) {
          var pieces = str.split("&"), data = {}, i, parts;
          // process each query pair
          for (i = 0; i < pieces.length; i++) {
              parts = pieces[i].split("=");
              if (parts.length < 2) {
                  parts.push("");
              }
              data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
          }
          return data;
      }

      const parseObjs = parseParms(queryObjs)
      if(parseObjs.pid == undefined){
        parseObjs["pid"] = goods.id

        const params = new URLSearchParams(parseObjs);
        const query = params.toString();
        const url =location.href.split("?")[0]+`?${query}`
        
        history.pushState({},'', url)
        this.showPopup(goods)
      }else if(parseObjs.pid != undefined ){
        delete parseObjs.pid
        parseObjs["pid"] = goods.id

        const params = new URLSearchParams(parseObjs);
        const query = params.toString();
        const url =location.href.split("?")[0]+`?${query}`
        
        history.pushState({},'', url)
        this.showPopup(goods)
      }
    },
    errorShowPopup(){
      console.log('error.. close overlay goodsitem')
      let queryObjs = location.href.split("?")[1]

      function parseParms(str) {
          let pieces = str.split("&"), data = {}, i, parts;
          // process each query pair
          for (i = 0; i < pieces.length; i++) {

              parts = pieces[i].split("=");
              if (parts.length < 2) {
                  parts.push("");
              }
              data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
          }
          return data;
      }

      const parseObjs = parseParms(queryObjs)
      if(parseObjs.pid != undefined){
        delete parseObjs.pid
      }

      const params = new URLSearchParams(parseObjs);
      const query = params.toString();
      const url =location.href.split("?")[0]+`?${query}`

      history.replaceState({},'', url)
    },
    showPopup (goods) {
      const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goods.id })
      getGoodsDetail('/app/index.php', whereJson).then(res => {
        const item = res.data
        let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)
        // response todo begin

        const getRouteQuery = () => {
        let tempParams = this.$route.query
        if (tempParams.h5api == undefined) {
          tempParams["h5api"] = 'on'
        }
        tempParams["do"] = 'validateBusinessAndHoliday' 
        return tempParams
        }
        const updateOption = () => {
        const queryParams = Object.assign(getRouteQuery(), {storeid: this.store_info.id});
        validateBusinessAndHoliday("/app/index.php", queryParams)
                .then(res => {
                  this.indexPage = res.data
                  this.store = this.indexPage.store
                  const table_type = this.store_info.table_type

                  if (table_type == 'is_meal'){
                    if (counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                    } else if ((counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                    } else if (this.store.is_rest != 1 || this.store.is_show != 1) {
                      this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                      this.errorShowPopup()
                    } else if (counts == 0 || (counts - today_counts) <= 0){
                      this.$toast("Oops, we regret to inform you that this product is out of stock")
                      this.errorShowPopup()
                    }
                  } else {
                    if (this.store.is_24_hours_operation == 0 && this.store.is_rest != 1 || this.store.is_show != 1) {
                      this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                      this.errorShowPopup()
                    }else if (goods.available == 0){
                      this.$toast("This product is unavailable!")
                      this.errorShowPopup()
                    } else if (this.store.is_24_hours_operation == 0 && counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                    } else if (this.store.is_24_hours_operation == 0 && (counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                    } else if (this.store.is_24_hours_operation == 1 && counts == -1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                    } else if (this.store.is_24_hours_operation == 1 && (counts - today_counts) > 0 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                    } else if (counts == 0 || (counts - today_counts) <= 0){
                      this.$toast("Oops, we regret to inform you that this product is out of stock")
                      this.errorShowPopup()
                    } else {
                      if (table_type && this.store_info[table_type] == 0) {
                        this.$toast(this.store_info.table_type_error)
                        this.errorShowPopup()
                      } else {
                        let newGoods = Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts})
                        this.$emit("evtShowPopup", newGoods)
                      }
                    }
                  }
                })
                .catch(error => {
                  // console.log('添加到购物车.error', error);
                });
        };
        updateOption();
        // response todo end 
      }).catch((error) => {
        console.log('====>error', error)
      })
    },
    checkItem (goods) {
        const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goods.id })
        getGoodsDetail('/app/index.php', whereJson)
        .then(res => {
            const item = res.data
            let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)
            
            // response todo begin
            console.log('counts',counts)
            console.log('today count',today_counts)

            const getRouteQuery = () => {
            let tempParams = this.$route.query
            if (tempParams.h5api == undefined) {
            tempParams["h5api"] = 'on'
            }
            if (tempParams.cart_id != undefined) {
              delete tempParams.cart_id
            }
            tempParams["do"] = 'validateBusinessAndHoliday' 
            return tempParams
            }
            const updateOption = () => {
            const queryParams = Object.assign(getRouteQuery(), {storeid: this.store_info.id});
            console.log('queryParams', queryParams)
            validateBusinessAndHoliday("/app/index.php", queryParams)
                    .then(res => {
                    this.indexPage = res.data
                    this.store = this.indexPage.store
                    console.log('res received', res.data)
                    const table_type = this.store_info.table_type

                    if (table_type == 'is_meal'){
                        if (counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                            this.addToCart(goods)
                        } else if ((counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                            let newGoods = Object.assign(item, {counts:counts - today_counts})
                            this.addToCart(newGoods)
                        } else if (this.store.is_rest != 1 || this.store.is_show != 1) {
                            this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                        } else if (counts == 0 || (counts - today_counts) <= 0){
                            this.$toast("Oops, we regret to inform you that this product is out of stock")
                        }
                    } else {
                        if (this.store.is_24_hours_operation == 0 && this.store.is_rest != 1 || this.store.is_show != 1) {
                            this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                        } else if (this.store.is_24_hours_operation == 0 && counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                            this.addToCart(goods)
                        } else if (this.store.is_24_hours_operation == 0 && (counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                            let newGoods = Object.assign(item, {counts:counts - today_counts})
                            this.addToCart(newGoods)
                        } else if (this.store.is_24_hours_operation == 1 && counts == -1 && this.store.is_show == 1){
                            this.addToCart(goods)
                        } else if (this.store.is_24_hours_operation == 1 && (counts - today_counts) > 0 && this.store.is_show == 1){
                            let newGoods = Object.assign(item, {counts:counts - today_counts})
                            this.addToCart(newGoods)
                        } else if (counts == 0 || (counts - today_counts) <= 0){
                            this.$toast("Oops, we regret to inform you that this product is out of stock")
                        } else {
                            if (table_type && this.store_info[table_type] == 0) {
                                this.$toast(this.store_info.table_type_error)
                                this.errorShowPopup()
                            } else {
                                let newGoods = Object.assign(item, {counts:counts - today_counts})
                                this.addToCart(newGoods)
                            }
                        }
                    }
                    })
                    .catch(error => {
                    // console.log('添加到购物车.error', error);
                    });
            };
            updateOption();
            // response todo end 
        }).catch((error) => {
            console.log('====>error', error)
        })
    },
    addToCart(goods){
      console.log('newgoodsss')
        let is_inventory = parseInt(goods.counts) != -1 && parseInt(goods.counts) >= 1 ? true : false;
        if (parseInt(goods.counts) == -1) {
            is_inventory = true;
        }
        if (is_inventory) {
            // 是否选择了规格
            const attr1 = {
                sky: goods.sky,
                sku: goods.sku,
                goodsid: goods.id,
                price: goods.marketprice,
                options: 0,
                qty: 1,
                optionname:  0,
                optionid: ""
            };
            const objQuery = this.getUrlParams({ do: "UpdateDishNumOfCategory" });
            const updateOption = () => {
                const queryParams = Object.assign(objQuery, {
                optype: "add",
                o2uNum: attr1.qty,
                optionid: attr1.optionid,
                dishid: attr1.goodsid
                });

                // console.log('添加到购物车.queryParams', queryParams);
                updateDishnumOfCategory("/app/index.php", queryParams)
                .then(res => {
                    const apiResData = {
                    totalprice: res.message.totalprice,
                    totalcount: res.message.totalcount,
                    cart: res.message.cartList,
                    products: false
                    };
                    if (parseInt(res.message.code) == 200) {
                    this.resetCart(apiResData);
                    } else {
                    this.$toast(res.message.msg);
                    }
                })
                .catch(error => {
                    // console.log('添加到购物车.error', error);
                });
            };
            
            updateOption && updateOption();
            
        } else {
            // console.log('数量超出太多了');
        }
    },
    MinusQty(goods){
      let goodItem = this.cart_goodslist.filter(e => e.goods_id == goods.id)[0]
      if(goodItem.optionid != "") return this.handleItem(goods)
      const operation = 'minus'
      this.checkItemAvailability(goodItem,operation)
    },
    PlusQty(goods){
      let goodItem = this.cart_goodslist.filter(e => e.goods_id == goods.id)[0]
      if(goodItem.optionid != "") return this.handleItem(goods)
      const operation = 'plus'
      this.checkItemAvailability(goodItem,operation)
    },
    delItem (goods) {
      let item = this.cart_goodslist.filter(e => e.goods_id == goods.id)[0]
    //删除单项内容
    const itemList =
        this.cart_goodslist &&
        this.cart_goodslist.filter((i, k) => {
        if (i.str_key != item.str_key) {
            return i;
        }
        });
    this.settingGoodsList(itemList);
      setTimeout(() => {
          const strIdx = item.str_key;
          const int_qty = 0;
          const itemData = {
          o2uNum: int_qty,
          optionid: item.optionid,
          dishid: item.goods_id
          };
          this.updateQty(itemData);
      }, 50);
      this.$emit("evtDeleteList", 'deleteItem')
    },
    async updateQty (itemData) {
        const getRouteQuery = () => {
            let tempParams = this.$route.query;
            if (tempParams.h5api == undefined) {
            tempParams["h5api"] = "on";
            }
            if (tempParams.cart_id != undefined) {
              delete tempParams.cart_id
            }
            tempParams["do"] = "UpdateDishNumOfCategory";
            return tempParams;
        };
        const queryParams = Object.assign(getRouteQuery(), itemData, {
            optype: ""
        });
        updateDishnumOfCategory("/app/index.php", queryParams)
            .then(res => {
            const oojStrkey = this.ooj.str_key;
            if (res.message.code == 0) {
                this.$toast(
                res.message.msg || "there are not items in your cartx!!!!"
                );
                this.cart_productqty[oojStrkey] = this.ooj.old_qty;
            } else {
                const newCartItemQty = Object.assign(this.cart_productqty, {
                [oojStrkey]: itemData.o2uNum
                });
                this.settingProductQty(newCartItemQty);

                const apiResData = {
                totalprice: res.message.totalprice,
                totalcount: res.message.totalcount,
                cart: res.message.cartList
                };
                this.totalCartSelected(apiResData.cart)
                const chooseList = () => {
                let arrList = {};
                apiResData.cart &&
                    apiResData.cart.forEach(cartItem => {
                        if (!arrList[cartItem.sku]) {
                            arrList[cartItem.sku] = [];
                        }
                        if (parseInt(cartItem.total) > 0) {
                            if (cartItem.optionid == '') {
                                arrList[cartItem.sku].push(cartItem.total + 'x ' + cartItem.optionname + ' (+RM ' + parseFloat(  cartItem.price * parseInt(cartItem.total) ).toFixed(2) + ')')
                            } else {
                                arrList[cartItem.sku].push(cartItem.total + 'x ' + cartItem.optionname + ' (+RM ' + parseFloat( cartItem.price ).toFixed(2) + ')')
                            }
                        }
                    });
                return arrList;
                };
                setTimeout(() => {
                // this.resetCart(apiResData)
                this.settingQty(apiResData.totalcount);
                this.settingSubtotal(apiResData.totalprice);
                this.settingChooseList(chooseList());
                }, 10);
            }
            })
            .catch(error => {
            // console.log("购物车更新====>error", error);
            });
    },
    totalCartSelected(carts){
        let sum_x= 0
        for( let i=0; i<carts.length; i++){
            sum_x += parseInt(carts[i].total)
        }
        this.setChooseListTotal = sum_x
        if(this.setChooseListTotal === 0){
            this.clearShoppingCart()
        }
    },
    clearShoppingCart () {
        console.log('clear')
        const getRouteQuery = () => {
            let tempParams = this.$route.query;
            if (tempParams.h5api == undefined) {
            tempParams["h5api"] = "on";
            }
            tempParams["do"] = "clearmenu";
            return tempParams;
        };
        const getApiParams = () => {
            return { type: "ajax" };
        };
        const queryParams = Object.assign(getRouteQuery(), getApiParams());
        this.cleanCart(queryParams).then(res => {
            console.log('clean success');
            //  this.$toast("clear success")
        }).catch(err => { });
    },
    checkItemAvailability(goodItem,operation){
    const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goodItem.goods_id })
        getGoodsDetail('/app/index.php', whereJson)
        .then(res => {
            const item = res.data
            this.newGoodsData = item
            let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)
            
            console.log('counts',counts)
            console.log('today count',today_counts)
            // response todo begin
            if (counts == -1) {
                this.changeQuantityItem(goodItem,operation)

            } else if (counts == 0 || (counts - today_counts) <= 0) {
                this.delItem(goodItem,operation)
                this.$toast("Oops, we regret to inform you that this product is out of stock")
            } else {
            const table_type = this.store_info.table_type
            if (this.store_info.is_24_hours_operation == 0 && this.store_info.is_rest != 1 || this.store_info.is_show != 1) {
                this.clearShoppingCart()
                this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
            } else {
                if (table_type && this.store_info[table_type] == 0) {
                this.$toast(this.store_info.table_type_error)
                } else if (parseInt(goodItem.qty) > 0 && parseInt(goodItem.qty) > (counts - today_counts)) {
                this.delItem(goodItem,operation)
                this.$toast("No more stock for this item!!")
                } else {
                    this.changeQuantityItem(goodItem,operation)
                }
            }
            }
            // response todo end 
        }).catch((error) => {
            console.log('====>error', error)
            this.$toast('Sorry, System busy. Please try it again later.')
        })
    },
    changeQuantityItem(goodItem,operation){
      console.log('operation',operation)
        let x = 0
        if( operation === 'plus'){
            x = parseInt(goodItem.qty) + 1
        }else{
            x = parseInt(goodItem.qty) - 1
        }
        const attr1 = {
            cart_id:goodItem.cart_id,
            sku: goodItem.sku,
            goodsid: goodItem.goods_id,
            price: goodItem.price,
            qty: x,
            optionname: goodItem.optionname ? goodItem.optionname : 0,
            optionid: goodItem.optionid ? goodItem.optionid : ""
        };
        const objQuery = this.getUrlParams({ do: "UpdateDishNumOfCategory" });
                const updateOption = () => {
                const queryParams = Object.assign(objQuery, {
                optype: "",
                cart_id: attr1.cart_id,
                o2uNum: attr1.qty,
                optionid: attr1.optionid,
                dishid: attr1.goodsid
                });
                updateDishnumOfCategory("/app/index.php", queryParams)
                .then(res => {
                    const cartList =
                    res.message.cartList &&
                    res.message.cartList.length &&
                    res.message.cartList.filter(item => parseFloat(item.total) > 0);
                    const apiResData = {
                    totalprice: res.message.totalprice,
                    totalcount: res.message.totalcount,
                    cart: cartList || []
                    };
                    if (parseInt(res.message.code) == 200) {
                    this.resetCart(apiResData);
                    } else {
                    this.$toast(res.message.msg);
                    }
                })
                .catch(error => {
                    // console.log("购物车规格更新.error", error);
                });
            };
            updateOption && updateOption();
    },
    editItem (goodItem, index) {
        const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goodItem.goods_id })
            getGoodsDetail('/app/index.php', whereJson)
            .then(res => {
                const item = res.data
                this.newGoodsData = item
                let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)

                // response todo begin
                if (counts == -1) {
                    this.editCartItemData(goodItem, index)
                } else if (counts == 0 || (counts - today_counts) <= 0) {
                    this.delItem(goodItem, index)
                    this.$toast("Oops, we regret to inform you that this product is out of stock")
                } else {
                const table_type = this.store_info.table_type
                if (this.store_info.is_24_hours_operation == 0 && this.store_info.is_rest != 1 || this.store_info.is_show != 1) {
                    this.clearShoppingCart()
                    this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                } else {
                    if (table_type && this.store_info[table_type] == 0) {
                    this.$toast(this.store_info.table_type_error)
                    } else if (parseInt(goodItem.qty) > 0 && parseInt(goodItem.qty) > (counts - today_counts)) {
                    this.delItem(goodItem, index)
                    this.$toast("No more stock for this item!!")
                    } else {
                        this.editCartItemData(goodItem, index)
                    }
                }
                }
                // response todo end 
            }).catch((error) => {
                console.log('====>error', error)
                this.$toast('Sorry, System busy. Please try it again later.')
            })
    },
    editCartItemData (goodItem, index) {
        this.setRadioAddons(""); //先设置默认值
        this.cart_id = goodItem.cart_id;
        this.currentGood = {};
        const curList = this.products;

        //此行无业务信息，只为了用户在每次打开指定组件时，触发指定组件的 created,mounted 钩子方法并运行
        this.timeVal = this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date();

        let counts = parseInt(this.newGoodsData.counts), today_counts = parseInt(this.newGoodsData.today_counts)

        curList && curList.forEach(item => {
            if (item.id == goodItem.goods_id && item.sku == goodItem.sku) {
                if (counts == -1){
                    this.currentGood = item
                }else{
                    this.currentGood = Object.assign(item, { counts: counts - today_counts })
                }
            }
        })
        console.log('currentGood',this.currentGood)
        console.log('counts',counts)
        console.log('today counts', today_counts)

        const good_item_options = goodItem.optionid.split("_");
        // console.log("[good_item_options].....", good_item_options);
        const finalAttr = this.currentGood["goods_attr_list"].length ? this.currentGood["goods_attr_list"] : false;
        const choosedData = this.getCartChoosedOption(finalAttr, good_item_options);

        const str_key_id = goodItem.sku + "-" + index + "-" + goodItem.goods_id;
        const str_key_qty = this.cart_productqty[str_key_id];

        //设置已选中的规格
        this.setRadioAddons(choosedData.attr);
        this.curChooseList = choosedData.mulattr;
        this.currentAttr = choosedData.mulattr;

        this.settingAttrRadio({ attr_list: finalAttr, choosed: goodItem });
        this.currentGood["isEdit"] = true;
        this.currentGood["choosedAttr"] = goodItem;
        this.qty = this.cart_productqty[str_key_id] || goodItem.qty;
        
        this.currentAttrTotal = this.fmPrice(goodItem.price * goodItem.qty);
        this.cartWinHeight = "100%";
        this.getCurrentAttrTotal();
        this.show = true;

        let urlParams = window.location.hash
        history.pushState( null, null, `${urlParams}`)
    },
    getCurrentAttrTotal () {
    setTimeout(() => {
        let attr_total = 0.0;
        if (this.currentGood) {
        attr_total = parseFloat(this.currentGood.marketprice);
        }
        this.currentAttr &&
        this.currentAttr.length &&
        this.currentAttr.forEach(priceItem => {
            attr_total = attr_total + parseFloat(priceItem.price);
        });
        this.currentAttrTotal = this.fmPrice(attr_total * this.qty);
    }, 10);
    },
    setIsRequired (isRequired) {
        this.isRequired = isRequired
    },
    updateAndSave () {
    let is_inventory = (parseInt(this.currentGood.counts) >= 1 &&
                        parseInt(this.qty) <= parseInt(this.currentGood.counts)) ? true : false

    if (parseInt(this.currentGood.counts) == -1) {
        is_inventory = true
    }

    if (is_inventory) {
        if (this.isRequired == false) {
        this.$toast('the require option can not empty')
        } else {
        const isChoosed = this.currentAttr ? true : false;
        const attr1 = {
            sky: this.currentGood.sky,
            sku: this.currentGood.sku,
            goodsid: this.currentGood.id,
            price: this.currentGood.marketprice,
            options: isChoosed ? this.currentAttr : 0,
            qty: this.qty,
            optionname: isChoosed ? this.getOptionName(this.currentAttr) : 0,
            optionid: isChoosed ? this.getOptionId(this.currentAttr) : ""
        };
        const objQuery = this.getUrlParams({ do: "UpdateDishNumOfCategory" });
        const updateOption = () => {
            const queryParams = Object.assign(objQuery, {
            optype: "",
            cart_id: this.cart_id,
            o2uNum: attr1.qty,
            optionid: attr1.optionid,
            dishid: attr1.goodsid
            });
            // console.log("购物车规格更新.queryParams", queryParams);
            updateDishnumOfCategory("/app/index.php", queryParams)
            .then(res => {
                const cartList =
                res.message.cartList &&
                res.message.cartList.length &&
                res.message.cartList.filter(item => parseFloat(item.total) > 0);
                const apiResData = {
                totalprice: res.message.totalprice,
                totalcount: res.message.totalcount,
                cart: cartList || []
                };
                if (parseInt(res.message.code) == 200) {
                this.resetCart(apiResData);
                this.cart_id = 0
                } else {
                this.$toast(res.message.msg);
                }
            })
            .catch(error => {
                // console.log("购物车规格更新.error", error);
            });
        };
        updateOption && updateOption();
        this.goBack();
        }
    } else {
        // console.log('数量超出太多了');
    }
    },
    closeEditPopup () {
      this.show = false;
    },
    goBack() {
      history.back()
    },
    chooseEditAttr (attrOptions) {
      this.currentAttr = attrOptions.attr || null;
      this.isSelectedAttr = true;
      setTimeout(() => {
        this.getCurrentAttrTotal();
      }, 10);
    },
  }
}
</script>

<style lang="less">
@import url('../../assets/css/common.less');
.app-container {
  font-family: Arial;
  padding: 5px;
  .tab-title {
    font-size: 24px;
    font-weight: 610;
    text-align: left;
    padding-left: 2px;
    // padding-top: 15px;
    // padding-bottom: 15px;
    margin-left: 5px;
    @media only screen and (max-width: 480px){
    }
    @media only screen and (max-width: 380px){
      font-size: 22px;
    }
  }
  .tab-description{
    margin-left: 5px;
    font-weight: 200;
    font-family: roboto;
    margin-bottom: 6px;
    @media only screen and (max-width: 480px){
      padding-bottom: 6px;
    }
  }
  .imgoutstock {
    opacity: 0.4;
    filter: alpha(opacity=40);
  }


  .app-item-list_gridView{
    @media only screen and (max-width: 950px){
      grid-template-columns: 1fr 1fr !important;
    }
    @media (max-width:480px){
      grid-gap: 10px !important;
    }
  }
  .app-item-list_viewList{
    grid-template-columns: 1fr 1fr 1fr !important;

    @media screen and (max-width: 1919px){
      grid-template-columns: 1fr 1fr !important;
    }
    @media (max-width:1070px){
      grid-template-columns: 1fr 1fr !important;
    }
    @media only screen and (max-width: 950px){
      grid-template-columns: 1fr !important;
    }
    @media (max-width:480px){
      grid-gap: 8px !important;
    }
  }
  .app-item-list {
    width: 100%;
    display: grid;
    grid-gap: 16px;
    
  .preorder {
    font-size:12px;
    font-weight: bold;
    position:absolute;
    left:5px;
    padding:3px;
    background-color: #FF0000;
    color: #FFFFFF;
    border-radius: 3px;
  }
  .preOrder {
    font-size:12px;
    font-weight: bold;
    margin-right: 3px;
    padding:0 2px;
    background-color: #008000;
    color: #FFFFFF;
    border-radius: 3px;
  }
  .prepare {
    font-size:12px;
    font-weight: bold;
    margin-right: 3px;
    padding:0 2px;
    background-color: #ff8c00;
    color: #FFFFFF;
    border-radius: 3px;
  }
  .item-preorder {
    font-weight: bold;
    font-size: 12px;
    padding: 0 2px;
    margin-right: 3px;
  }
  .item-prepare {
    font-weight: bold;
    font-size: 12px;
    padding: 0 2px;
    margin-right: 3px;
  }

    .bottom-border {
      border-bottom:1px solid @white9;
    }
    .row {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background-color: @fff;
      max-height: 130px;
      height: 100%;
      overflow: hidden;
      margin-top: 0;
      margin-left: 0px;
      @media screen and (max-width: 950px){
        min-height: 90px;
        max-height: none;
      }
      .item-price {
        margin-left: auto;
        display:flex;
        justify-content: flex-end;
        font-weight: 600;
        font-size: @size14;
        padding: 0 5px;
        margin-right: 5px;
        span{
          font-weight: 200;
        }
        .ori-price {
          text-decoration: line-through;
          color: @main;
          font-weight: normal;
          font-size: @size12;
          margin-left: 5px;
        }
      }

      .row-item_viewGrid{
        @media screen and (max-width: 600px){
          flex-direction: column;
          margin: 0 !important;
          padding-top: 0 !important;
          margin-bottom: 8px !important;

          .item-image {
            flex-basis: auto !important;
            margin-left: 0 !important;
            display: block;

            .item-image-cont {
                height: 110px !important;
                width: 100% !important;
              img {
                display: block !important;
                border-radius: 0 !important;
                object-fit: cover !important;

                max-width: 100% !important;
                max-height: 100% !important;
                width: 100% !important;
                height: 100% !important;
              }
            }
          }

          .item-content{
            margin-top: 10px !important;
            .item-name{
              margin-bottom: 5px !important;
            }
            .item-desc{
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .item-choosed{
              max-height: 30px !important;
            }
          }

        }
      }
      .row-item {
        color: @gray5;
        display: flex;
        margin: 5px 0 15px 0;
        padding-top: 10px;

        @media screen and (max-width: 480px){
          margin: 1px 0 5px 0;
          padding-top: 1px;
        }
        .item-image {
          flex-basis: 105px;
          margin-left: 5px;
          .item-image-cont{
            position: relative;
            
            // flex-basis: 100px;
          // div {
            width: 100%;
            img {
              display: block;
              width: 100px;
              max-height: 80px;
              object-fit: contain;
              // width: 100%;
              // max-width: 100px;
              // max-height: 75px;
              border-radius: 5px;
            }
          }
          .btn-best-cont{
              position: absolute;
              bottom: 8px;
              right: 10px;
              background: white;
              border-radius: 20px;
          }
          .btn-edit{
              display: flex;
              align-items: center;
          }
        }
        .item-content {
          max-height: 76px;
          margin: 0;
          overflow-y:auto ;
          scrollbar-width: thin !important; //mozilla scroll bar
          @media screen and (max-width: 950px){
            max-height: 105px;
            padding-right: 2px;
          }
          .outofstock {
            color: #999;
          }
          .item-info {
            height: 100%;
            text-align: left;
            margin-left: 8px;
            padding-right: 5px;

            // display: flex;
            // flex-flow: row wrap;
            // align-content: space-between;

            .out-of-stock {
              color: @red;
              font-size: @size10;
            }

            .item-name {
              font-weight: 400;
              font-size: @size14;
              line-height: @size16;
              overflow: hidden !important;
            //   // height: 38px;
            //   overflow: hidden;
            // }
            // .item-price {
            //   font-weight: 600;
            //   font-size: @size14;
            //   padding: 0 5px;
            //   .ori-price {
            //     text-decoration: line-through;
            //     color: @red;
            //     font-weight: normal;
            //     font-size: @size12;
            //   }
            }
            .item-choosed {
              color: #1da70e;
              font-size: 10px;
              text-align: left;
            }
            .item-desc {
              font-size: @size12;
              line-height: @size15;
              color: @rgba-Color2;
              width: 200px;
              overflow: hidden;

              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              @media screen and (max-width: 950px){
                max-height: 60px;
              }
            }
          }
        }
      }

      // 弹出窗口
      .attr-wapper {
        // border-radius: 5px 5px 0 0;
        .attr-body {
          padding: 80px 0 100px 0;
          background-color: #f0f0f0;
        }
      }
      .posTop {
        z-index: 2998;
        top: 0;
        padding: 10px 10px;
      }
      .posBottom {
        z-index: 2999;
        bottom: 0;
      }
      .btn-okey {
        left: 0;
        right: 0;

        // border-radius: 5px 5px 0 0;
        background-color: #fbfbfb;
        .item-quanity {
          justify-content: center;
          padding: 10px 0;
        }
        .item-name {
          // padding: 8px 10px;
          text-align: left;
          line-height: 18px;
          font-weight: bold;
        }
        .attr-qty {
          margin: 0 10px;
        }
        .confirm-btn {
          padding: 12px 16px;
          border-radius: 0;
          background-color: @red;
          color: @fff;
          font-weight: 800;
        }
      }
      .item-attr {
        text-align: left;
        background-color: #fff;
        // padding: 0 10px;
        margin: 10px 0 0 0;
        .attr-title {
          padding: 5px 0;
          font-weight: 700;
          margin: 0 0 0 0;
        }
        .attr-list {
          padding: 5px;
        }
      }
      .item-qty {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.01);
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
}


.attr-bottom {
    font-family:Arial;
    position: fixed;
    // max-width: 800px;
    width: 100%;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3002;
    box-shadow: 0px -2px 3px -1px rgba(202, 201, 201, 0.452);
    @media only screen and (max-width: 2560px) {
        max-width: 1200px;
    }
    @media only screen and (max-width: 1920px) {
        max-width: 900px;
    }
    @media only screen and (max-width: 1600px) {
        max-width: 700px;
    }
    @media only screen and (max-width: 1280px) {
        max-width: 500px;
    }
    @media only screen and (max-width: 820px) {
    max-width: 100vw;
    }
}

.pos-bottom {
    padding: 12px;
    text-align: center;
    background-color: @fff;
    @media only screen and (max-width: 480px){
        padding: 11px 10px 25px 0;
    }
    @media only screen and (max-width: 380px){
        padding: 11px 10px 25px 5px;
    }
    @media only screen and (max-width: 320px){
        padding: 11px 4px 11px 0;
    }

    .goods-inventory{
        margin-left: 80px;
        text-align: left;
        padding-bottom: 5px;
        font-size: 14px;
        color: @green3;
        @media only screen and (max-width: 600px){
        margin-left: 25px;
        }
        @media only screen and (max-width: 420px){
        display: none;
        }
    }
}
.select-quanity {
    display: flex;
    align-items: center;
    margin: 0 10px;
    text-align: center;
    font-weight: bold;
    @media only screen and (max-width: 420px){
        margin: 0;
    }

    button{
        background-color: @fff;
        width: 40px !important;
        height: 40px !important;
        @media only screen and (max-width: 480px){
        width: 35px !important;
        height: 35px !important;
        }
    }
    input{
        background-color: @fff;
        width: 40px !important;
        height: 40px !important;
        font-size: 17px !important;
        @media only screen and (max-width: 480px){
        width: 35px !important;
        height: 35px !important;
        }
        @media only screen and (max-width: 380px){
        width: 30px !important;
        height: 35px !important;
        }
        @media only screen and (max-width: 320px){
        font-size: 15px !important;
        }
    }
    .van-stepper{
        width: 100%;
        max-width:250px;
        @media only screen and (max-width: 1280px){
          max-width:140px !important;
        }
        @media only screen and (max-width: 600px){
        max-width:140px;
        }
        @media only screen and (max-width: 360px){
        max-width:120px;
        }
        .van-stepper__minus,
        .van-stepper__plus {
        color: @main;
        transition:all .2s ease-in-out ;
        border-radius: 50%;
        }
        .van-stepper__minus:active,
        .van-stepper__plus:active {
        background-color: rgb(233, 233, 233);
        }
        .van-stepper__minus--disabled,
        .van-stepper__plus--disabled {
        color: grey;
        }
    } 
    .btn-on-bg {
    background-color: @main;
}
.btn-off-bg {
    background-color: rgb(193 193 193);
}
.no-more-item {
    background-color: @gray10 !important;
}
.confirm-btn {
    color:@fff !important;
    padding: 20px !important;
    box-shadow: -1px 2px 8px 1px rgba(0, 0, 0, 0.6);
    -webkit-box-shadow: -1px 5px 8px 1px rgba(0,0,0,0.6);
    -moz-box-shadow: -1px 5px 8px 1px rgba(0,0,0,0.6);
    flex: 1;
    color: @fff;
    font-size: 16px;
    margin: 0 0 0 16px;
    cursor: pointer;
    transition: all 0.1s cubic-bezier(.08,.76,0,1.02);
    
    @media only screen and (max-width: 460px) {
    padding:10px;
    font-size: 14px;
    margin-left: 10px;
    }
    @media only screen and (max-width: 380px) {
    font-size: 12px;
    }
    @media only screen and (max-width: 380px) {
        margin-left: 2px;
    }
}
.confirm-btn:active{
    transform: scale(0.98);
} 
}
</style>